export enum PermissionMode {
  Allow = "Allow",
  Deny = "Deny",
}
